import React, { useContext } from 'react';
import htmlParse from 'react-html-parser';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Checkbox from '@material-ui/core/Checkbox';
import ThemesFilterComp from './ThemesFilterComp';
import AppContext from '../../../contexts/AppContext';

import './ImageFilterComp.css';

export default function ImageFilterComp({
  nImages,
  onLandscapeChanged,
  onBtsChanged,
  onGacCollectionChanged,
  onThemesChanged,
  onRandomize,
  imagesTotalCount,
  themes,
}) {
  const { dictionnary } = useContext(AppContext);

  const [ratioFilter, setRatioFiler] = React.useState({
    landscape: true,
    portrait: true,
    bts: true,
    gac: true,
  });

  const handleRatioChange = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    onLandscapeChanged(filter);
  };

  const handleBtsChange = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    onBtsChanged(filter);
  };

  const handleGacCollection = (event) => {
    const filter = {
      ...ratioFilter,
      [event.target.name]: event.target.checked,
    };
    setRatioFiler(filter);
    onGacCollectionChanged(filter);
  };

  const handleThemesChanged = (selectedThemes) => {
    if (onThemesChanged) {
      onThemesChanged(selectedThemes);
    }
  };

  const landscapeTxt = dictionnary.get('edit-landscape');
  const portraitTxt = dictionnary.get('edit-portrait');

  const headerText = htmlParse(
    dictionnary.get('edit-header').replace('{xxx}', imagesTotalCount),
  );

  return (
    <div id="filter-panel">
      <h6>{htmlParse(dictionnary.get('edit-title'))}</h6>
      <p className="spaced">{headerText}</p>
      <h6 className="spaced">{dictionnary.get('edit-filter-format')}</h6>
      <FormGroup className="formgroup">
        <FormControlLabel
          control={
            <Checkbox
              checked={ratioFilter.landscape}
              onChange={handleRatioChange}
              name="landscape"
              color="primary"
              style={{
                marginRight: '10px',
              }}
            />
          }
          label={ratioFilter.landscape ? <b>{landscapeTxt}</b> : landscapeTxt}
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={ratioFilter.portrait}
              onChange={handleRatioChange}
              name="portrait"
              color="primary"
              style={{
                marginRight: '10px',
              }}
            />
          }
          label={ratioFilter.portrait ? <b>{portraitTxt}</b> : portraitTxt}
        />
      </FormGroup>
      <h6 className="spaced">{dictionnary.get('edit-filter-type')}</h6>
      <FormGroup className="formgroup">
        <FormControlLabel
          control={
            <Checkbox
              checked={ratioFilter.bts}
              onChange={handleBtsChange}
              name="bts"
              color="primary"
              style={{
                marginRight: '10px',
              }}
            />
          }
          label={
            ratioFilter.bts ? (
              <b>{dictionnary.get('edit-filter-bts')}</b>
            ) : (
              dictionnary.get('edit-filter-bts')
            )
          }
        />
        <FormControlLabel
          control={
            <Checkbox
              checked={ratioFilter.gac}
              onChange={handleGacCollection}
              name="gac"
              color="primary"
              style={{
                marginRight: '10px',
              }}
            />
          }
          label={
            ratioFilter.gac ? (
              <b>{dictionnary.get('edit-filter-gac')}</b>
            ) : (
              dictionnary.get('edit-filter-gac')
            )
          }
        />
      </FormGroup>
      <h6 className="spaced">{dictionnary.get('edit-filter-theme')}</h6>
      <FormGroup className="formgroup formgroup-themes">
        <ThemesFilterComp
          themes={themes}
          onThemeChanged={(selectedThemes) =>
            handleThemesChanged(selectedThemes)
          }
        />
      </FormGroup>
      <p className="spaced">
        {nImages} {dictionnary.get('edit-filter-found')}
      </p>
      <div className="centered-content spaced">
        <button
          type="button"
          className="main-button main-button--outline"
          onClick={() => {
            onRandomize();
          }}
        >
          {dictionnary.get('edit-filter-randomize')}
        </button>
      </div>
    </div>
  );
}
